import { render } from "./ResourceGroup.vue?vue&type=template&id=085ea736"
import script from "./ResourceGroup.vue?vue&type=script&lang=js"
export * from "./ResourceGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__